<template>
<v-card style="height:90vh">

<v-toolbar height="42" color="#242F3B" dark flat>
<v-card-title class="ma-0 pa-0">
<span  style="font-size:1.4em">
  <span v-if="init.isCreator">
  Создание нового фильтра
  </span>
  <span v-else>
  Редактировать: {{filter.name}}
  </span>
</span>

</v-card-title>
<v-spacer></v-spacer>
<v-icon  @click="close()"> mdi-close</v-icon>
</v-toolbar>



<v-card-text>
<v-text-field v-model="filter.name" color="#4A76A8"  label="Введите название фильтра" clearable></v-text-field>
<div  >
<v-slider label="Начальный балл" v-model="filter.weight" hide-details color="#4A76A8" thumb-label="always" min="-100">
<v-layout slot="append"  >
<v-btn class="white--text" color="grey" @click="--filter.weight" small icon><v-icon>mdi-minus</v-icon></v-btn>
<v-btn class="white--text" color="grey" @click="++filter.weight" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-layout>
</v-slider>
</div>

<div>
<b-card no-body>
<b-tabs   card>

<b-tab>

<template #title>
<v-icon small color="#232F3A">mdi-account</v-icon> <strong style="margin-left:5px">Параметры страницы</strong>
</template>

<h6 style="color:orange" >Личные данные</h6>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isMan.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Мужской пол</span></v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isMan.weight" v-if="filter.filters[0].isMan.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isMan.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isMan.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isMan.weight" v-if="filter.filters[0].isMan.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isWoman.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Женский пол</span></v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isWoman.weight" v-if="filter.filters[0].isWoman.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isWoman.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isWoman.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isWoman.weight" v-if="filter.filters[0].isWoman.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title>
<v-checkbox color="#232F3A" v-model="filter.filters[0].isAgeMore.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Возраст более или равен: </span>
</v-checkbox>
</v-toolbar-title>
<v-text-field mask="####" type="number" autofocus background-color="#F5F5F5" v-if="filter.filters[0].isAgeMore.active" v-model="filter.filters[0].isAgeMore.params.count"  solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isAgeMore.weight" v-if="filter.filters[0].isAgeMore.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isAgeMore.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isAgeMore.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isAgeMore.weight" v-if="filter.filters[0].isAgeMore.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isAgeLess.active"  hide-details>
<span style="color:#232F3A;margin-top:6px" slot="label">Возраст менее или равен: </span>
</v-checkbox></v-toolbar-title>
<v-text-field v-if="filter.filters[0].isAgeLess.active" v-model="filter.filters[0].isAgeLess.params.count" mask="####" type="number" autofocus background-color="#F5F5F5"   solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isAgeLess.weight" v-if="filter.filters[0].isAgeLess.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isAgeLess.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isAgeLess.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isAgeLess.weight" v-if="filter.filters[0].isAgeLess.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<h6 style="color:orange;margin-top:25px" >Приватность аккаунта</h6>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isClosedProfile.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Закрытый профиль</span></v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isClosedProfile.weight" v-if="filter.filters[0].isClosedProfile.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isClosedProfile.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isClosedProfile.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isClosedProfile.weight" v-if="filter.filters[0].isClosedProfile.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isOpenProfile.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Открытый профиль</span></v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isOpenProfile.weight" v-if="filter.filters[0].isOpenProfile.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isOpenProfile.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isOpenProfile.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isOpenProfile.weight" v-if="filter.filters[0].isOpenProfile.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isOpenMsg.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Открытые сообщения</span></v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isOpenMsg.weight" v-if="filter.filters[0].isOpenMsg.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isOpenMsg.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isOpenMsg.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isOpenMsg.weight" v-if="filter.filters[0].isOpenMsg.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isOpenFriendsReq.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Открыты заявки в друзья</span></v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isOpenFriendsReq.weight" v-if="filter.filters[0].isOpenFriendsReq.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isOpenFriendsReq.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isOpenFriendsReq.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isOpenFriendsReq.weight" v-if="filter.filters[0].isOpenFriendsReq.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<h6 style="color:orange;margin-top:25px" >Счетчик активности</h6>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title>
<v-checkbox color="#232F3A" v-model="filter.filters[0].isFriendsMore.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Друзей более чем: </span>
</v-checkbox>
</v-toolbar-title>
<v-text-field mask="####" type="number" autofocus background-color="#F5F5F5" v-if="filter.filters[0].isFriendsMore.active" v-model="filter.filters[0].isFriendsMore.params.count"  solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isFriendsMore.weight" v-if="filter.filters[0].isFriendsMore.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isFriendsMore.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isFriendsMore.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isFriendsMore.weight" v-if="filter.filters[0].isFriendsMore.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isFriendsLess.active"  hide-details>
<span style="color:#232F3A;margin-top:6px" slot="label">Друзей  менее чем: </span>
</v-checkbox></v-toolbar-title>
<v-text-field v-if="filter.filters[0].isFriendsLess.active" v-model="filter.filters[0].isFriendsLess.params.count" mask="####" type="number" autofocus background-color="#F5F5F5"   solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isFriendsLess.weight" v-if="filter.filters[0].isFriendsLess.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isFriendsLess.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isFriendsLess.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isFriendsLess.weight" v-if="filter.filters[0].isFriendsLess.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>



<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isFollowersMore.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подписчиков более чем: </span>
</v-checkbox></v-toolbar-title>
<v-text-field v-if="filter.filters[0].isFollowersMore.active" v-model="filter.filters[0].isFollowersMore.params.count" mask="####" type="number" autofocus background-color="#F5F5F5"   solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isFollowersMore.weight" v-if="filter.filters[0].isFollowersMore.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isFollowersMore.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isFollowersMore.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isFollowersMore.weight" v-if="filter.filters[0].isFollowersMore.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isFollowersLess.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подписчиков  менее чем: </span>
</v-checkbox></v-toolbar-title>
<v-text-field v-if="filter.filters[0].isFollowersLess.active" v-model="filter.filters[0].isFollowersLess.params.count" mask="########" type="number" autofocus background-color="#F5F5F5"   solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isFollowersLess.weight" v-if="filter.filters[0].isFollowersLess.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isFollowersLess.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isFollowersLess.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isFollowersLess.weight" v-if="filter.filters[0].isFollowersLess.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isFollowMore.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подписок более чем: </span>
</v-checkbox></v-toolbar-title>
<v-text-field v-if="filter.filters[0].isFollowMore.active" v-model="filter.filters[0].isFollowMore.params.count" mask="########" type="number" autofocus background-color="#F5F5F5"   solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isFollowMore.weight" v-if="filter.filters[0].isFollowMore.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isFollowMore.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isFollowMore.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isFollowMore.weight" v-if="filter.filters[0].isFollowMore.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isFollowLess.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подписок менее чем: </span>
</v-checkbox></v-toolbar-title>
<v-text-field v-if="filter.filters[0].isFollowLess.active" v-model="filter.filters[0].isFollowLess.params.count" mask="####" type="number" autofocus background-color="#F5F5F5"   solo flat style="max-width:90px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isFollowLess.weight" v-if="filter.filters[0].isFollowLess.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isFollowLess.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isFollowLess.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isFollowLess.weight" v-if="filter.filters[0].isFollowLess.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<h6 style="color:orange;margin-top:25px" >Другое</h6>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isEngName.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Латиница в имени</span>
</v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isEngName.weight" v-if="filter.filters[0].isEngName.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isEngName.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isEngName.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isEngName.weight" v-if="filter.filters[0].isEngName.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title @click.stop="openParams('endsOfLastName')"><v-checkbox color="#232F3A"  v-model="filter.filters[0].endsOfLastName.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Окончание фамилии</span>
</v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].endsOfLastName.weight" v-if="filter.filters[0].endsOfLastName.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].endsOfLastName.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].endsOfLastName.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].endsOfLastName.weight" v-if="filter.filters[0].endsOfLastName.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title @click.stop="openParams('isOfflineLots')"><v-checkbox color="#232F3A"  v-model="filter.filters[0].isOfflineLots.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Давно не был в сети</span>
</v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isOfflineLots.weight" v-if="filter.filters[0].isOfflineLots.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isOfflineLots.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isOfflineLots.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isOfflineLots.weight" v-if="filter.filters[0].isOfflineLots.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title @click.stop="openParams('isPhotosInOneTime')"><v-checkbox color="#232F3A" v-model="filter.filters[0].isPhotosInOneTime.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Фото загружено в один день</span>
</v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isPhotosInOneTime.weight" v-if="filter.filters[0].isPhotosInOneTime.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isPhotosInOneTime.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isPhotosInOneTime.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isPhotosInOneTime.weight" v-if="filter.filters[0].isPhotosInOneTime.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isIdBigger.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">ID более чем</span>
</v-checkbox></v-toolbar-title>
<v-text-field mask="##############" type="number" autofocus background-color="#F5F5F5" v-if="filter.filters[0].isIdBigger.active" v-model="filter.filters[0].isIdBigger.params.id"  solo flat style="max-width:150px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isIdBigger.weight" v-if="filter.filters[0].isIdBigger.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isIdBigger.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isIdBigger.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isIdBigger.weight" v-if="filter.filters[0].isIdBigger.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isIdSmaller.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">ID менее чем</span>
</v-checkbox></v-toolbar-title>
<v-text-field mask="##############" type="number" autofocus background-color="#F5F5F5" v-if="filter.filters[0].isIdSmaller.active" v-model="filter.filters[0].isIdSmaller.params.id"  solo flat style="max-width:150px;margin-top:6px;" height="12" dense hide-details>
</v-text-field>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isIdSmaller.weight" v-if="filter.filters[0].isIdSmaller.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isIdSmaller.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isIdSmaller.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isIdSmaller.weight" v-if="filter.filters[0].isIdSmaller.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isWithoutAva.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Отсутствует аватар</span>
</v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isWithoutAva.weight" v-if="filter.filters[0].isWithoutAva.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isWithoutAva.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isWithoutAva.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isWithoutAva.weight" v-if="filter.filters[0].isWithoutAva.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

</b-tab>


<b-tab>

<template #title>
<v-icon small color="yellow">mdi-tune</v-icon> <strong style="margin-left:5px">Другое</strong>
</template>

<h6 style="color:orange;margin-top:25px" >Подозрительна активность</h6>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title><v-checkbox color="#232F3A" v-model="filter.filters[0].isSuspectRepost.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подозрительные репосты</span>
</v-checkbox></v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isSuspectRepost.weight" v-if="filter.filters[0].isSuspectRepost.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isSuspectRepost.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isSuspectRepost.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isSuspectRepost.weight" v-if="filter.filters[0].isSuspectRepost.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>


<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title @click="openParams('isSuspectTraffIds')">
<v-checkbox color="#232F3A" v-model="filter.filters[0].isSuspectTraffIds.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подозрительные ids входящего трафика (Активность)</span>
</v-checkbox>
</v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isSuspectTraffIds.weight" v-if="filter.filters[0].isSuspectTraffIds.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isSuspectTraffIds.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isSuspectTraffIds.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isSuspectTraffIds.weight" v-if="filter.filters[0].isSuspectTraffIds.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

<v-toolbar flat dense style="margin-top:25px;">
<v-toolbar-title @click="openParams('isSuspectPublicsIds')">
<v-checkbox color="#232F3A" v-model="filter.filters[0].isSuspectPublicsIds.active" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Подозрительные ids пабликов (куда подписался)</span>
</v-checkbox>
</v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="--filter.filters[0].isSuspectPublicsIds.weight" v-if="filter.filters[0].isSuspectPublicsIds.active" small icon><v-icon>mdi-minus</v-icon></v-btn>
<div v-if="filter.filters[0].isSuspectPublicsIds.active" style="width:200px;">
<v-slider  v-model="filter.filters[0].isSuspectPublicsIds.weight" hide-details color="#4A76A8" thumb-label="always" min="-100"></v-slider>
</div>
<v-btn @click="++filter.filters[0].isSuspectPublicsIds.weight" v-if="filter.filters[0].isSuspectPublicsIds.active" small icon><v-icon>mdi-plus</v-icon></v-btn>
</v-toolbar>

</b-tab>

</b-tabs>
</b-card>
</div>

<filterParams :init="init" :filter="filter"></filterParams>

</v-card-text>

<v-card-actions>

<v-select label="Тип фильтра" style="margin-left:25px" v-model="filter.selectedType" :items="filter.types"></v-select>

<v-spacer/>
<v-btn @click="addSk()" style="text-transform:none"   color="#4A76A8"   flat>
<v-icon v-if="init.isCreator">mdi-plus</v-icon>
<v-icon   left v-else>mdi-lead-pencil</v-icon>
<span v-if="init.isCreator">Создать фильтр</span> <span v-else>Редактировать фильтр</span></v-btn>
</v-card-actions>

</v-card>

</template>

<script>
import filterParams from './filterParams.vue'
import axios from 'axios'
export default {
 components:{filterParams},
 props: ['filter','init'],
  data () {
    return {

    }
  },
methods: {

openParams(val){

if(this.filter.filters[0].[val].active){
  this.init.paramsModSelected = val
  this.init.paramsMod = true
}
},

addSk(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/filter/add.php', {
method: 'POST',
data: {
id: this.init.selectedFilterId,
isCreator: this.init.isCreator,
params : this.filter,
}
})
.then( response => {
this.init.skList  = response.data
this.init.modals.creator =  false
this.$router.go()
})
},


close(){
//this.init.isCreator = true
//this.init.modals.creator = false
this.$router.go()
},




  },
  computed:{

  },
  mounted(){

  },

}
</script>

<style    >

</style>
